import {
  RECEIVED_ONBOARDINGS
} from './actions'
import {
  CLEAR_AUTH_USER
} from '../auth/actions'

export default function reducer (state = {
  data: []
}, action) {
  switch (action.type) {
    case RECEIVED_ONBOARDINGS:
      return {
        ...state,
        data: action.onboardings
      }
    case CLEAR_AUTH_USER:
      return {
        data: []
      }
    default:
      return state
  }
}
